export default {
  title: "خطأ في الخادم",
  description: `<p>
              عذرًا، حدث خطأ ما من جانبنا. نحن نعمل بجد لحل المشكلة.
            </p>
            <p>
              شكرًا لصبرك. يرجى المحاولة مرة أخرى بعد لحظات قليلة.
            </p>`,
};
